import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Create and append the gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-2FZWT0S8D0';
    document.head.appendChild(script1);
    // Create and append the gtag config script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2FZWT0S8D0');
    `;
    document.head.appendChild(script2);
    // Cleanup function
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  return null;
}